cv.CustomFieldsView = Marionette.CompositeView.extend({
  template : cv.Templates['global/custom_fields_form/custom_fields'],
  childViewContainer: '.custom-fields',
  childView : cv.CustomFieldsRowView,
  emptyView : cv.CustomFieldsRowEmptyView,

  bindings : {
    ':el' : {
      observe : 'group_style',
      update: function($el, value, model, options){
        if(model.get('group_style') == 'one_column'){
          $el.find('.custom-fields').removeClass('clearfix');
          $el.find('.custom-fields').removeClass('custom-fields-two-column');
          $el.find('.custom-fields').removeClass('custom-fields-three-column');
        }
        if(model.get('group_style') == 'two_column'){
          $el.find('.custom-fields').addClass('clearfix');
          $el.find('.custom-fields').addClass('custom-fields-two-column');
          $el.find('.custom-fields').removeClass('custom-fields-three-column');
        }
        if(model.get('group_style') == 'three_column'){
          $el.find('.custom-fields').addClass('clearfix');
          $el.find('.custom-fields').removeClass('custom-fields-two-column');
          $el.find('.custom-fields').addClass('custom-fields-three-column');
        }
      }
    }
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications: true
  }],

  events: {
    'update-field-sort': 'updateSort',
    'click .remove-row' : 'removeRow'
  },

  validation : {
  },

  childEvents: {
    'show' : function() {
    },
    'render' : function() {
    }
  },

  collectionEvents: {
    'reset' : 'collectionReset'
  },

  childViewOptions: function(model, index) {
    // do some calculations based on the model
    return {
      edit_mode : this.options.edit_mode,
      values : this.options.values,
      group_index : this.options.group_index,
      nested : this.options.nested,
      is_donation_form : this.options.is_donation_form
    }
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.edit_form = false;

    // Unlink handler
    this.listenTo(vent, 'custom_field:unlink_field', function(view){
      this.trigger('form:unlink', view);
    }, this);

    // View modes
    this.listenTo(vent, 'custom_field:edit_form', function(){
    }, this);
    this.listenTo(vent, 'custom_field:preview_form', function(){
    }, this);

    console.log('CustomFieldsView initialized');
  },

  removeRow: function(e){
    e.preventDefault();

    if(this.options.edit_mode == true){
      // Pop up the modal
      var view = new cv.AlertView({
        title : 'Preview Mode',
        message : 'Removing a row is disabled in preview mode.  This is just to show you how it looks.'
      });
      vent.trigger('modal:show', view);

      return false;
    }

    if(this.model.collection.length == 1){
      return;
    }

    var view = new cv.ConfirmView({
      title : 'Remove row?',
      message : 'Are you sure you want to remove this row?'
    });
    vent.trigger('modal:show', view);

    view.on('confirm', function(){
      this.model.collection.remove(this.model);
    }, this);
  },

  templateHelpers: function(){
    return {
      is_edit_mode : this.options.edit_mode,
      is_nested : this.options.nested,
      is_repeating : (this.model.get('type') == 'repeating' && this.options.edit_mode == true) || (this.options.nested == true && this.options.edit_mode == false) ? true : false
    }
  },

  updateSort: function(event, model, position){        
    this.collection.remove(model, { silent : true });

    this.collection.each(function (model, index) {
      var ordinal = index;
      if (index >= position) {
          ordinal += 1;
      }
      model.set('ordinal', ordinal);
    });            

    model.set('ordinal', position);
    this.collection.add(model, {at: position, silent : true});

    // to update ordinals on server:
    var ids = this.collection.pluck('id');
    console.log('post ids to server: ' + ids.join(', '));
  },

  collectionReset: function(){
    this.$('.custom-fields').html('');
  },

  attachHtml: function(collectionView, childView, index){
    collectionView.trigger('form:link', childView);

    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    }
    else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)){
        collectionView._insertAfter(childView);
      }
    }
  },

  // Called after all children have been appended into the elBuffer
  attachBuffer: function(collectionView, buffer) {
    collectionView.$('.custom-fields').append(buffer);

    // Add some otehr crap
    if((this.model.get('type') == 'repeating' && this.options.edit_mode == true) || (this.options.nested == true && this.options.edit_mode == false)){
      collectionView.$('.custom-fields').append(cv.Templates['global/custom_fields_form/custom_fields_row_remove']);
    }
  },

  isEmpty: function(collection){
    if(collection.length == 0){
      return true;
    }
    return false;
  },

  onRender: function(){
    this.stickit(this.model);

    if(this.options.edit_mode == true){
      this.$('.custom-fields').sortable({
        handle: '.custom-field-heading',
        update: _.bind(function(event, ui){
          ui.item.trigger('dropField', ui.item.index());
        }, this)
      });
    }
  },

  onDestroy: function(){
    if(this.options.edit_mode == true && this.$('.custom-fields').hasClass('ui-sortable')){
      this.$('.custom-fields').sortable('destroy');
    }

    vent.trigger('custom_field:unlink_fields', this);
  }
});
